import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Channel } from '../../../../../core/shared/models/channel.model';
import { GetChannels } from '../../../../../core/shared/actions/channel.actions';
import { ChannelState } from '../../../../../core/shared/states/channel.state';
import { ChannelModalComponent } from '../../modals/channel-modal/channel-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatIcon,
    MatIconButton,
    LoadingSpinnerComponent,
  ],
})
export class ChannelListComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() public applicationName!: string;
  @Input() public admin!: boolean;
  channel!: Channel;
  public dataSource = new MatTableDataSource<Channel>();
  public displayedColumns = ['channel_name', 'Description', 'actions'];
  public loading = true;
  public readonly channels: Observable<Channel[]>;

  constructor(
    private store: Store,

    public modalService: NgbModal
  ) {
    this.channels = this.store.select(ChannelState.getChannelList);
  }

  ngOnInit() {
    this.store.dispatch(new GetChannels(this.applicationName, 'test'));

    this.channels.subscribe((data) => {
      this.dataSource.data = data;
      this.loading = false;
    });
  }

  openModal(
    applicationName: string,
    channel: Channel,
    formMode: string,
    editChannel: boolean
  ) {
    // Open modal form component
    const modalRef = this.modalService.open(ChannelModalComponent, {
      size: 'lg',
    });
    // pass into form component variable
    modalRef.componentInstance.channel = channel;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editChannel = editChannel;
    // pass into form component variable formMode
    modalRef.componentInstance.formMode = formMode;

  }

    //search bar
    applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
